module.exports = __webpack_public_path__ + "static/VectrexWeb-Bold-cbaf18e565a86b05c462b194849cc671.woff";